import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Login = () => import('@/views/login')
const Home = () => import('@/views/home')

export default new Router({
  routes: [
    {
      path: '/',
      redirect:'/login'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '检验管理'
      },
      component: Home
    }
  ]
})

